<template>
    <div class="mb-3">
        <div>
            <label
                for="customer_image_upload"
                class="font-semibold inline-block border border-primary px-4 py-2 my-3 rounded transition-fast select-none text-primary hover:bg-primary hover:text-white"
            >
                <div class="flex">
                    <Spinner
                        v-if="uploading"
                        :line-size="2"
                        size="18"
                        class="h-4 mr-3 icon"
                    />
                    Upload image
                </div>
            </label>
            <input
                id="customer_image_upload"
                type="file"
                class="hidden"
                @change="onFileChange"
            >
            <p class="text-xs">
                For best results please upload high resolution photos to ensure a sharp print. Low resolution images may be pixelated or blurred when printed.
            </p>
        </div>
        <cropper
            v-if="image"
            ref="cropper"
            class="cropper"
            :src="image"
            :stencil-props="{
                aspectRatio: 1,
            }"
            @change="crop"
        />
    </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import Button from '@/components/Button';
import Spinner from '@/components/Spinner';
import 'vue-advanced-cropper/dist/style.css';
import handleException from '@/plugins/error-handler.client';

export default {
    components: {
        Button,
        Spinner,
        Cropper,
    },
    data() {
        return {
            image: null,
            uploading: false,
        };
    },
    methods: {
        onFileChange(e) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
        },
        createImage(file) {
            const formData = new FormData();
            formData.append('file', file);
            this.uploading = true;

            this.$axios.$post('basket/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response) => {
                this.image = response.url;
                this.uploading = false;

                this.updateImage({
                    image: this.image,
                    width: 0,
                    height: 0,
                    preview: this.image,
                });
            }).catch((error) => {
                this.uploading = false;
                handleException(error, 'Please upload an image in JPEG or PNG format that is a maximum file size of 20 MB.');
            });
        },
        crop({ coordinates, canvas }) {
            this.updateImage({
                image: this.image,
                width: coordinates.width,
                height: coordinates.height,
                preview: canvas.toDataURL(),
            });
        },
        updateImage({ image, width, height, preview }) {
            this.$store.dispatch('product/setShowProductCustomisationImage', true);
            this.$store.dispatch('product/setCustomerImageUrl', this.image);
            this.$store.dispatch('product/setCustomerImageWidth', width);
            this.$store.dispatch('product/setCustomerImageHeight', height);
            this.$store.dispatch('product/setCustomerImagePreview', preview);

            this.$emit('imageUpdated', {
                url: image,
                width,
                height,
                preview,
            });
        },
    },
};
</script>

<style>
.cropper {
    @apply w-64 md:w-96 h-64 my-4
}
</style>
